import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { sanityClient, urlFor } from "../lib/sanityClient";
import { fadeUp, stagger, viewport } from "../lib/motion";
import "../styles/Benefits.css";

const QUERY = `*[_type == "benefitsSection"][0]{
  heading, benefitCards
}`;

const Benefits = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    sanityClient.fetch(QUERY).then(setData);
  }, []);

  if (!data) return null;

  const benefits = data.benefitCards || [];

  return (
    <section className="benefits-section" id="benefits">
      <div className="benefits-radial" />
      <div className="benefits-sidebar left" />
      <div className="benefits-sidebar right" />

      <div className="benefits-wrapper">
        <motion.h2
          className="benefits-heading"
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          variants={fadeUp}
        >
          {data.heading}
        </motion.h2>
        <motion.div
          className="benefits-grid"
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          variants={stagger(0.12)}
        >
          {benefits.map((benefit) => (
            <motion.div key={benefit._key} className="animated-border-card" variants={fadeUp}>
              <div className="benefit-card">
                <motion.img
                  src={urlFor(benefit.icon).url()}
                  alt={`${benefit.title} icon`}
                  className="benefit-icon"
                  variants={{
                    hidden: { opacity: 0, scale: 0.5, rotate: -12 },
                    visible: {
                      opacity: 1,
                      scale: 1,
                      rotate: 0,
                      transition: { type: "spring", stiffness: 200, damping: 16, delay: 0.15 },
                    },
                  }}
                />
                <h3 className="benefit-title">{benefit.title}</h3>
                <p className="benefit-description" style={{ whiteSpace: "pre-line" }}>
                  {(benefit.description || "").replace(/\\n/g, "\n")}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Benefits;
